import React from "react";

import { MDSSessionStandardView } from "@/mds/components/sessions/session-content/views/session-standard-view";
import { MDSSessionNotificationView } from "@/mds/components/sessions/session-content/views/session-notification-view";
import { MDSSessionPreviewView } from "@/mds/components/sessions/session-content/views/session-preview-view";
import { SessionViewMode } from "@/mds/components/sessions/session.constants";

type Props = {
  mode: SessionViewMode;
};

export const MDSSessionContentRenderer: React.FC<Props> = ({ mode }) => {
  switch (mode) {
    case SessionViewMode.Standard:
      return <MDSSessionStandardView />;
    case SessionViewMode.Notification:
      return <MDSSessionNotificationView />;
    case SessionViewMode.Preview:
      return <MDSSessionPreviewView />;
    default:
      return null;
  }
};
